export default {
  'company': {
    'key': 'company',
    'name': '所在企业',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'job_title': {
    'key': 'job_title',
    'name': '职位',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'job_title_content': {
    'key': 'job_title_content',
    'name': '',
    'subName': '请填写您的职位名称 (选填）',
    'required': false
  },
  'company_industry': {
    'key': 'company_industry',
    'name': '行业领域',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'company_type': {
    'key': 'company_type',
    'name': '融资阶段',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'company_scale': {
    'key': 'company_scale',
    'name': '企业规模（人数）',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'company_remark': {
    'key': 'company_remark',
    'name': '备注',
    'layout': 'compaction'
  },
  'company_develop': {
    'key': 'company_develop',
    'name': '企业研发团队规模（人数）',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'managed_team_size': {
    'key': 'managed_team_size',
    'name': '本人现带领团队规模（人数）',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'development_team_size': {
    'key': 'development_team_size',
    'name': '本人曾带领团队最大规模（人数）',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'developed_start_year': {
    'key': 'developed_start_year',
    'name': '从事研发工作起始年',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'managed_start_year': {
    'key': 'managed_start_year',
    'name': '从事管理工作起始年',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'study_experience': {
    'key': 'study_experience',
    'name': '教育经历',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'work_experience': {
    'key': 'work_experience',
    'name': '工作经历',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'support_resource': {
    'key': 'support_resource',
    'name': '可提供的资源',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'want_resource': {
    'key': 'want_resource',
    'name': '期望获得的价值',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'achievements': {
    'key': 'achievements',
    'name': '职业成就',
    'required': true,
    'regName': 'checkIsEmpty'
  }
}
